import { render, staticRenderFns } from "./CustomerShippingInformationCopyDialog.vue?vue&type=template&id=a30d44e2&"
import script from "./CustomerShippingInformationCopyDialog.vue?vue&type=script&lang=js&"
export * from "./CustomerShippingInformationCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a30d44e2')) {
      api.createRecord('a30d44e2', component.options)
    } else {
      api.reload('a30d44e2', component.options)
    }
    module.hot.accept("./CustomerShippingInformationCopyDialog.vue?vue&type=template&id=a30d44e2&", function () {
      api.rerender('a30d44e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/prePlanBookingJc/CustomerShippingInformationCopyDialog.vue"
export default component.exports